import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { NetworkTableAction } from "stores/ChargingNetworkStore/NetworkTableAction";

const mapStateToProps = (state) => {
  return {
    NetworkTableList: state.NetworkTable.NetworkTableList,
    isloadingNetworkTable: state.NetworkTable.NetworkTable,
    AddChargingNetworkList: state.NetworkTable.AddChargingNetworkList,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getNetworkTableAction: NetworkTableAction.getNetworkTable,
      postChargingNetworkAction: NetworkTableAction.postChargingNetworkAction,
      AddChargingNetworkEnableDisableAction:
        NetworkTableAction.AddChargingNetworkEnableDisable,
      UpdateChargingNetworkAction:
        NetworkTableAction.UdateChargingNetworkAction,
    },
    dispatch
  );

const ChargingNetworkStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default ChargingNetworkStore;
